import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id EFBBDF1F-1497-4BA3-AE93-614B2BB496F7
 * name bookmark-check-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-check-outline.svg
 * tags
 */
export const BookmarkCheckOutlineIcon = createSvgIcon(<><path d="M9.47 9.65L8.06 11.07L11 14L16.19 8.82L14.78 7.4L11 11.18M17 3H7C5.9 3 5 3.9 5 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3M17 18L12 15.82L7 18V5H17Z" /></>, 'BookmarkCheckOutlineIcon');
export default BookmarkCheckOutlineIcon